import { FrameRectangle } from '../../../../../../common/components/cart-loader/frame-rectangle/FrameRectangle';
import { ProductCardListLoader } from '../../../list-loaders/product-card-list-loader/ProductCardListLoader';
import styles from './MultipleItemDrawerLoader.module.scss';

export const MultipleItemDrawerLoader = () => (
  <div data-testid="multiple-item-drawer-loader" className={styles['mutiple-item-drawer-loader']}>
    {[...Array(4).keys()].map((key) => (
      <div key={key} className={styles['mutiple-item-drawer-loader-card']}>
        <FrameRectangle className={styles['mutiple-item-drawer-loader-card-box']} />
        <ProductCardListLoader fromDrawer={true} forceMobileView={true} />
      </div>
    ))}
  </div>
);
